import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { RouterModule } from '@angular/router';
import { LocationService } from '@services/location.service';
import { map, Observable, takeUntil } from 'rxjs';
import { Location } from '../../models/location.model';
import { SubscribedComponent } from 'src/app/lib/subscribed.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { BrandStore } from '@services/brand.store';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    NzTypographyModule,
    RouterModule,
    TranslateModule,
  ],
})
export class FooterComponent extends SubscribedComponent implements OnInit {
  location: Location;
  year: number;

  copyrightKey!: string;
  copyrightParams: Record<string, string | number> = {};
  translatedPoweredByText$: Observable<string>;
  brand$ = this.brandStore.brand$;

  constructor(
    private ref: ChangeDetectorRef,
    private locationService: LocationService,
    private translate: TranslateService,
    private brandStore: BrandStore,
  ) {
    super();
  }

  ngOnInit(): void {
    this.year = new Date().getFullYear();

    this.locationService.locationChanged.pipe(takeUntil(this.destroyed$)).subscribe((location) => {
      this.location = location;
      this.updateCopyrightText();
      this.translateFooterText();
      this.ref.markForCheck();
    });

    this.location = this.locationService.getLocation();
    this.updateCopyrightText();
  }

  translateFooterText(): void {
    const brand = this.brandStore.getSnapshot();
    const anchor = `<a href="https://${brand.domain}" target="_blank" rel="nofollow" class="app-footer-link">${brand.name}</a>`;
    this.translatedPoweredByText$ = this.translate
      .stream('shared.footer.label-powered-by')
      .pipe(map((text) => text.replace('{{timeTailorLink}}', anchor)));
  }

  private updateCopyrightText(): void {
    const businessName = this.location?.businessName ?? '';
    const companyName = this.location?.billingDetails?.companyName ?? '';
    const year = this.year;

    const companyNameExists = companyName && companyName !== businessName;

    if (companyNameExists) {
      this.copyrightKey = 'shared.footer.label-copyright-operated';
      this.copyrightParams = { businessName, companyName, year };
    } else {
      this.copyrightKey = 'shared.footer.label-copyright-simple';
      this.copyrightParams = { businessName, year };
    }
  }
}
